import { Column } from 'new/elements/Table/types';
import { Link } from 'react-router-dom';
import React from 'react';
import { ReactComponent as Key } from 'new/components/icons/key.svg';
import { ReactComponent as Delete } from 'new/components/icons/fi-rr-trash.svg';
import { Stack } from 'new/elements/Stack';
import { Button } from 'new/elements/Button';
import { RESOURCE_TYPE_DATA_SET } from 'js/constants/resourceTypes';

const getDescriptionMap = (resourceType) => {
  if (resourceType === RESOURCE_TYPE_DATA_SET) {
    return {
      ['admin']: 'View, Transform, and Share Data',
      ['sharer']: 'Can use Nexset data to create a new Nexset',
    };
  }
  return {
    ['admin']: 'Can modify, use, share, anything',
    ['collaborator']: "Access to APIs for viewing, use, but can't modify it ",
    ['operator']: 'Can start and stop, access monitoring APIs and use it',
  };
};

export default function (resource: any, selected: any, rowSelected: any, sharedTo: 'me' | 'other') {
  return [
    {
      name: resource.name + ' ID',
      renderRow(row: any) {
        return <Link to="">{row.id}</Link>;
      },
    },
    {
      name: selected ? `${selected.full_name || selected.name}'s permissions` : 'My permissions',
      renderRow(row: any) {
        return getDescriptionMap(resource.value)[row.role] || 'Not able to define permissions';
      },
    },
    {
      name: '',
      numeric: true,
      renderRow(row: any) {
        if (rowSelected?.id === row.id) {
          return (
            <Stack direction="row" alignItems="center">
              {sharedTo === 'me' ? null : (
                <Button variant="text" color="inherit" startIcon={<Key />}>
                  Manage access
                </Button>
              )}
              <Button variant="text" color="error" startIcon={<Delete />}>
                {sharedTo === 'me' ? 'Revoke my access' : 'Revoke access'}
              </Button>
            </Stack>
          );
        }
        return null;
      },
    },
  ] as Column<any>[];
}
